// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".error[data-v-c050198c]{display:flex;flex-direction:column;justify-content:flex-end;width:100%;height:100vh;background-size:cover;background-position:50%;color:#1a1a1a;text-align:center}@media(max-width:768px){.error[data-v-c050198c]{background-size:20%}}.error[data-v-c050198c]:visited,.error a[data-v-c050198c]{color:#60f;margin:1rem 0 3rem}.error a[data-v-c050198c]:hover{color:#555}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
